import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBlackFridaySettings } from '../../selectors/blackFriday';
import { LabeledBlackFridayBanner } from '@cian/frontend-black-friday-banner';
import { NBSP } from '../../constants/symbols';
import { BannerLayout } from '../../components/BannerLayout';
import { useInView } from '@cian/valuation-utils-component';
import { trackBannerClick, trackBannerShow } from './tracking';
import { selectSavedFilters } from '../../selectors/filters';
import { SavedFiltersIds } from '../../interfaces/filters';

export const BlackFridayBannerContainer: React.FC = () => {
  const { isActive, url } = useSelector(selectBlackFridaySettings);
  const { items: filters } = useSelector(selectSavedFilters);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView) {
      trackBannerShow();
    }
  }, [inView]);

  if (!isActive || !url || filters.some(({ id }) => id === SavedFiltersIds.BlackFriday)) {
    return null;
  }

  return (
    <BannerLayout ref={ref}>
      <LabeledBlackFridayBanner
        href={url}
        description={`Выберите дом и${NBSP}позвоните по${NBSP}номеру в${NBSP}объявлении`}
        onClick={trackBannerClick}
      />
    </BannerLayout>
  );
};
